import { ACCESS_TOKEN_KEY, removeCookie } from 'src/services/cookies';

import { useRouter } from './use-router';
import { paths } from '../paths';
import useUserStore from 'src/store/useUserStore';

const useAuth = () => {
  const router = useRouter();
  const { setUserId } = useUserStore();
  // const [auth, setAuth] = useRecoilState(authStore);

  const logout = () => {
    removeCookie(ACCESS_TOKEN_KEY);
    setUserId('');
    router.push(paths.auth.login);
    // console.log('logout');
  };

  // 로그아웃 API 요청
  // const { mutateAsync: logout } = useMutation({
  //   mutationFn: async (path: string | undefined | void = undefined) => {
  //     const res = await authFetch.logout(path);
  //     return res;
  //   },
  //   onSuccess: (res) => {
  //     queryClient.invalidateQueries(); //로그아웃시 모든 쿼리 무효화.
  //     // setAuth(DEFAULT_AUTH_STATE);
  //
  //     router.push(res?.path || paths.auth.jwt.login);
  //   }
  // });

  return { logout };
};

export default useAuth;
